import { JwtPayload } from 'jwt-decode';

export interface User extends JwtPayload {
    id: string;
    nom: string;
    prenom: string;
    num_adherent: string;
    roles: string[];
    login: string;
    token: string;
    token_mercure: string;
    account?: string;
    accountUpdatedAt?: Date;
    winDebToken?: string;
    features?: string;
}

export const defaultUser: User = {
    id: '',
    login: '',
    roles: [],
    token: '',
    token_mercure: '',
    nom: '',
    num_adherent: '',
    prenom: '',
    account: '',
    features: '',
};
